import { render, staticRenderFns } from "./tableBaseTemplate.vue?vue&type=template&id=2f4bc622&scoped=true&"
import script from "./tableBaseTemplate.vue?vue&type=script&lang=js&"
export * from "./tableBaseTemplate.vue?vue&type=script&lang=js&"
import style0 from "./tableBaseTemplate.vue?vue&type=style&index=0&id=2f4bc622&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4bc622",
  null
  
)

export default component.exports